import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { AuthModal } from 'src/components/AuthModal'
import { useStore } from 'src/stores'
import { logout } from 'src/stores/login/actions'
import { getTokenExpirationDelay } from 'src/utils/getTokenExpirationDelay'
import * as session from 'src/utils/session'

interface AuthWrapperProps {
  children: React.ReactNode
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const {
    state: {
      login: { currentUser },
    },
    dispatch,
  } = useStore()
  const history = useHistory()

  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    const handleTokenExpiration = async () => {
      const token = await session.getJwtToken()
      if (!token) return

      const delay = getTokenExpirationDelay(token)
      if (delay === null) return

      const warningThreshold = 5000

      let modalTimeout: ReturnType<typeof setTimeout> | undefined
      if (delay > warningThreshold) {
        modalTimeout = setTimeout(() => {
          setShowModal(true)
        }, delay - warningThreshold)
      } else {
        setShowModal(true)
      }

      const logoutTimeout = setTimeout(() => {
        dispatch(logout())
        history.push('/login')
      }, delay)

      return () => {
        clearTimeout(logoutTimeout)
        if (modalTimeout) clearTimeout(modalTimeout)
      }
    }

    if (currentUser) {
      handleTokenExpiration()
    }
  }, [currentUser, dispatch, history])

  return (
    <>
      {showModal && <AuthModal message="Votre session a expiré. Redirection vers la page de connexion en cours.." />}
      {children}
    </>
  )
}

export default AuthWrapper
